// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sale from "../../modules/Sale/Sale.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";

let baseRoute = "/sales";

function make(saleType) {
  return {
    saleType: saleType
  };
}

let codec = JsonCodec.object1(param => Sale.toString(param.saleType), saleType => ({
  TAG: "Ok",
  _0: {
    saleType: Sale.fromStringExn(saleType)
  }
}), JsonCodec.field("saleType", JsonCodec.string));

let SalesListRouteExtraParams = {
  make: make,
  codec: codec
};

function make$1(id, name, business) {
  return {
    id: id,
    name: name,
    business: business
  };
}

let codec$1 = JsonCodec.object3(param => [
  param.id,
  param.name,
  param.business
], param => ({
  TAG: "Ok",
  _0: {
    id: param[0],
    name: param[1],
    business: param[2]
  }
}), JsonCodec.field("id", JsonCodec.string), JsonCodec.field("name", JsonCodec.string), JsonCodec.field("business", JsonCodec.bool));

let SalesListRouteCustomer = {
  make: make$1,
  codec: codec$1
};

function make$2(customer, shopId) {
  return {
    customer: customer,
    shopId: shopId
  };
}

let codec$2 = JsonCodec.object2(param => [
  param.customer,
  param.shopId
], param => ({
  TAG: "Ok",
  _0: {
    customer: param[0],
    shopId: param[1]
  }
}), JsonCodec.optional(JsonCodec.field("customer", codec$1)), JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)));

let SalesListRouteFilters = {
  SalesListRouteCustomer: SalesListRouteCustomer,
  make: make$2,
  codec: codec$2
};

let codec$3 = JsonCodec.object2(param => [
  param.filters,
  param.extra
], param => ({
  TAG: "Ok",
  _0: {
    filters: param[0],
    extra: param[1]
  }
}), JsonCodec.field("filters", codec$2), JsonCodec.optional(JsonCodec.field("extra", codec)));

let SalesListRouteQueryStringCodecs = {
  SalesListRouteExtraParams: SalesListRouteExtraParams,
  SalesListRouteFilters: SalesListRouteFilters,
  codec: codec$3
};

function encodeListQueryString(state) {
  return QueryString.stringify(JsonCodec.encodeWith(state, codec$3));
}

function routeWithQueryString(route, queryString) {
  if (queryString === "") {
    return route;
  } else {
    return route + "?" + queryString;
  }
}

function listRoute(saleType, customerId, customerName, customerIsBusiness, shopId) {
  let customer = customerId !== undefined && customerName !== undefined && customerIsBusiness !== undefined ? ({
      id: customerId,
      name: customerName,
      business: customerIsBusiness
    }) : undefined;
  let extra = saleType !== undefined ? ({
      saleType: saleType
    }) : undefined;
  return routeWithQueryString(baseRoute, encodeListQueryString({
    filters: {
      customer: customer,
      shopId: shopId
    },
    extra: extra
  }));
}

function invoiceListRoute(customerId, customerName, customerIsBusiness, shopId) {
  return listRoute("Invoice", customerId, customerName, customerIsBusiness, shopId);
}

function receiptListRoute(customerId, customerName, customerIsBusiness, shopId) {
  return listRoute("SalesReceipt", customerId, customerName, customerIsBusiness, shopId);
}

function creditNoteListRoute(customerId, customerName, customerIsBusiness, shopId) {
  return listRoute("CreditNote", customerId, customerName, customerIsBusiness, shopId);
}

function refundReceiptListRoute(customerId, customerName, customerIsBusiness, shopId) {
  return listRoute("RefundReceipt", customerId, customerName, customerIsBusiness, shopId);
}

function deliveryNoteListRoute(customerId, customerName, customerIsBusiness, shopId) {
  return listRoute("DeliveryNote", customerId, customerName, customerIsBusiness, shopId);
}

function quoteListRoute(customerId, customerName, customerIsBusiness, shopId) {
  return listRoute("Quote", customerId, customerName, customerIsBusiness, shopId);
}

function showRoute(saleType, id) {
  let tmp;
  switch (saleType) {
    case "Invoice" :
      tmp = "/invoice/";
      break;
    case "SalesReceipt" :
      tmp = "/receipt/";
      break;
    case "CreditNote" :
      tmp = "/credit-note/";
      break;
    case "RefundReceipt" :
      tmp = "/refund-receipt/";
      break;
    case "DeliveryNote" :
      tmp = "/delivery-note/";
      break;
    case "Quote" :
      tmp = "/quote/";
      break;
  }
  return baseRoute + tmp + id;
}

export {
  baseRoute,
  SalesListRouteQueryStringCodecs,
  encodeListQueryString,
  routeWithQueryString,
  listRoute,
  invoiceListRoute,
  receiptListRoute,
  creditNoteListRoute,
  refundReceiptListRoute,
  deliveryNoteListRoute,
  quoteListRoute,
  showRoute,
}
/* codec Not a pure module */
